import "./DonationBody.css";
import React from "react";

export default function DonationBody() {
  return (
    <div className="DonationBody">
      <div className="mainDonate">
        <div className="left-donate"></div>
        <div className="right-donate">
          <h1>Banking Details</h1>
          <hr />
          <br />
          <h2>Claremont Main Road Mosque Building Fund</h2>
          <br />
          <p>Bank: First National Bank</p>
          <br />
          <p>Branch: Vineyard</p>
          <br />
          <p>Branch Code: 2000109</p>
          <br />
          <p>Account No.: 62666627939</p>
          <br />
          <div className="donation-section">
            <div className="payfast-logo">
              <button>
                <a
                  style={{ textDecoration: "none" }}
                  href="https://www.payfast.co.za/donate/go/cmrm"
                  target="new"
                >
                  <img src="assets/Payfast-logo2.png" alt="" />
                  <p>Donate Now</p>
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
